import React, { useState, useEffect } from "react";
import Navbar from "../navbar/navbar";
import Aboutimage from "./../../assets/residential/Sam/sam house 02 3d.jpg";
import { motion } from "framer-motion";

const Hero = () => {
  const [stopScroll, setStopScroll] = useState(false);

  useEffect(() => {
    document.documentElement.style.overflowX = "hidden";
    document.body.style.overflowX = "hidden";
    document.body.style.overflowY = "hidden";
    return () => {
      document.documentElement.style.overflowX = "";
      document.body.style.overflowX = "";
      document.body.style.overflowY = "";
    };
  }, []);

  // 🎯 Ultra-Smooth Scrolling with requestAnimationFrame
  const smoothScrollTo = (targetPosition, duration = 800) => {
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animationStep(timestamp) {
      if (!startTime) startTime = timestamp;
      const timeElapsed = timestamp - startTime;
      const progress = Math.min(timeElapsed / duration, 1); // Ensure it doesn't exceed 1

      // Ease-in-out quadratic function for smooth scrolling
      const easeInOutQuad = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      window.scrollTo(0, startPosition + distance * easeInOutQuad);

      if (timeElapsed < duration) {
        requestAnimationFrame(animationStep);
      }
    }

    requestAnimationFrame(animationStep);
  };

  // 📌 Function to scroll to the "Learn More" section
  const scrollToLearnMore = () => {
    const section = document.getElementById("learn-more-section");
    if (section) {
      const yOffset = section.getBoundingClientRect().top + window.scrollY - 50; // Adjust for navbar
      smoothScrollTo(yOffset, 1000); // 🔥 Ultra-smooth scroll with 1s duration
    }
  };

  return (
    <div style={{ overflowX: "hidden", width: "100vw" }}>
      <Navbar passedScrollLimit={true} setStopScroll={setStopScroll} />

      {/* Hero Section */}
      <section style={{ position: "relative", height: "100vh", width: "100vw", overflow: "hidden" }}>
        <img src={Aboutimage} alt="Hero Background" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: -1 }} />

        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", color: "white", textAlign: "center", width: "90%" ,textShadow: "0px 0px 10px rgba(0,0,0,1)",}}>
          <h1 style={{ fontSize: "clamp(2rem, 5vw, 3rem)", fontWeight: "bold", marginBottom: "0px" }}>
            We aim to offer seamless and reliable services <h1  style={{ fontSize: "clamp(2rem, 5vw, 3rem)", fontWeight: "bold", marginBottom: "0px" }}>that cater to your needs.</h1>
          </h1>

          {/* Motion Button for Smooth Scroll */}
          <motion.button
            style={{
              position: "relative",
              height: "50px",
              overflow: "hidden",
              padding: "12px 24px",
              marginTop: "30px",
              fontSize: "18px",
              fontWeight: "bold",
              background: "transparent",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            initial={{ color: "grey" }}
            whileHover={{ color: "white" }}
            onClick={scrollToLearnMore} // 🔥 Smooth Scroll on Click
          >
            <motion.span
              style={{
                position: "absolute",
                inset: 5,
                background: "#5c0e14",
                borderRadius: "8px",
              }}
              initial={{ x: "-100%" }}
              whileHover={{ x: 0, transition: { duration: 0.4 } }}
            />
            <span style={{ position: "relative", zIndex: 1, color: "white" ,textShadow: "0px 0px 10px rgba(0,0,0,1)",}}>Learn more</span>
          </motion.button>
        </div>

        <p style={{ position: "absolute", bottom: "20px", left: "50%", transform: "translateX(-50%)", color: "white", fontSize: "24px", textAlign: "center", width: "100%" }}>
          Architecture | Interior Designs | Exterior Designs
        </p>
      </section>

       {/* Learn More Section with Staggered Slide-in Animation */}
       <section id="learn-more-section" style={{ padding: "50px", background: "#f4f4f4", textAlign: "center" }}>
        
        {/* Slide-in heading with delay */}
        <motion.h2
          style={{ fontSize: "28px", color: "#333", opacity: 0 }} // Default opacity 0
          initial={{ x: "-50%", opacity: 0 }} // Start from left (-100%) and invisible
          whileInView={{ x: 0, opacity: 1 }} // Animate to visible state
          transition={{ duration: 1, ease: "easeOut", delay: 0.2 }} // Delay for smooth stagger
          viewport={{ once: true }} // Only animate once
        >
          More About Our Services
        </motion.h2>

        {/* Slide-in paragraph with more delay */}
        <motion.p
          style={{ fontSize: "18px", maxWidth: "600px", margin: "auto", color: "#555", opacity: 0 }}
          initial={{ x: "50%", opacity: 0 }} // Start from right (100%) and invisible
          whileInView={{ x: 0, opacity: 1 }} // Animate to visible state
          transition={{ duration: 1, ease: "easeOut", delay: 0.6 }} // More delay than heading
          viewport={{ once: true }}
        >
          We provide top-notch architecture, interior, and exterior design solutions tailored to your needs.
        </motion.p>

      </section>
    </div>
  );
};

export default Hero;
